import React, { useState, useEffect } from 'react';
import { Modal, Container, Dropdown, Grid, Button, Icon } from 'semantic-ui-react';
import {getCompanyDocument} from '../../../firebase';

const EditarAlmacenPrincipal = ({ onModalSubmit, almacenes }) => {
  const [almPrincipal, setAlmPrincipal] = useState('');
  const [dropdown, setOptions] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [boton, setBoton] = useState(true);

  useEffect(() => {
    const dropdownData = almacenes.map((item, index) => ({
      key: index,
      text: item,
      value: item,
    }))
    setOptions(dropdownData)
    const isButtonDisabled = !(almPrincipal)
    setBoton(isButtonDisabled)
  }, [almPrincipal, almacenes])
  
  const handleSave = async () => {
    const company = await getCompanyDocument()
    await company.update({
      almPrincipal: almPrincipal
    })
    setOpenModal(false)
    onModalSubmit()
    alert("Datos Guardados")
  }
  const handleDropdownChange = (e, { value }) => {
    setAlmPrincipal(value)
  }

  return (
    <label>
    <button className='editar' onClick={()=>setOpenModal(true)}>
      <Icon name='edit' />
    </button>
    <Modal 
      open={openModal}
      onOpen={()=>setOpenModal(true)}
      onClose={()=>setOpenModal(false)}
    >
      <Modal.Header>
        <Container textAlign="center">
          Cambiar el almacén principal
        </Container>
      </Modal.Header>
      <Modal.Content>
        <Grid columns={2} divided >
          <Grid.Row>
            <Grid.Column>
                <Container textAlign='right'>
                  <p>Las compras se agregarán a:</p>
                </Container>
            </Grid.Column>
            <Grid.Column>
              <Container textAlign='left'>
              <Dropdown 
                selection
                name="almPrincipal"
                options={dropdown}
                value={almPrincipal}
                placeholder='Almacen Principal'
                onChange={handleDropdownChange}
              />
              </Container>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={()=>handleSave()} disabled={boton}>
          Enviar
        </Button>
      </Modal.Actions>
    </Modal>
    </label>
  );
};

export default EditarAlmacenPrincipal;
